import { render, staticRenderFns } from "./EditRates.vue?vue&type=template&id=ff1e970a"
import script from "./EditRates.vue?vue&type=script&lang=js"
export * from "./EditRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports